import * as React from 'react';

import { IconName } from '../../../enums';
import { ArtworkDetails } from '../../../interfaces';
import { BoxTitle } from '../../boxTitle/boxTitle.component';
import { Icon } from '../../icon/icon.component';

import {
  Container,
  Details,
  IconButton,
  ImageElement,
  ImagePlaceholder,
} from './artworkContainer.styled';
import { ArtworkContainerProps } from './artworkContainer.types';

export const ArtworkContainer: React.FC<ArtworkContainerProps> = (props: ArtworkContainerProps): JSX.Element => {
  const { artworkDetails, onRemoveItem, index, className }: ArtworkContainerProps = props;
  const { boxTitleDetails, image }: ArtworkDetails = artworkDetails;

  return (
    <Container className={className}>
      {image ? (
        <ImageElement src={image} alt={artworkDetails.imageAlt ?? ''} onClick={artworkDetails.onClick} />
      ) : (
        <ImagePlaceholder onClick={artworkDetails.onClick}>
          <Icon name={IconName.Image} size={50} />
        </ImagePlaceholder>
      )}
      <Details>
        <BoxTitle boxTitleDetails={boxTitleDetails} />
      </Details>
      {!!onRemoveItem && (
        <IconButton 
          onClick={onRemoveItem} 
          data-testid='artwork-container-remove-button' 
          id={`artwork-container-remove-button-${index ?? ''}`}
        >
          <Icon name={IconName.Delete} size={18} />
        </IconButton>
      )}
    </Container>
  );
};
